import { Box, VStack, HStack, Text, Badge } from '@chakra-ui/react';
import type { ContactNote } from '../../types/contactDetail'

interface NotesSectionProps {
  notes: ContactNote[]
}

const noteTypeColors: Record<string, string> = {
  General: 'gray',
  FollowUp: 'yellow',
  Alert: 'red',
}

export function NotesSection({ notes }: NotesSectionProps) {
  if (notes.length === 0) {
    return (
      <Box bg="surface" p={8} borderRadius="lg" shadow="md" textAlign="center">
        <Text color="gray.500">No notes recorded.</Text>
      </Box>
    )
  }

  return (
    <VStack gap={3} align="stretch">
      {notes.map((note) => (
        <Box key={note.id} bg="surface" p={4} borderRadius="lg" shadow="sm" borderLeft="3px solid"
          borderLeftColor={
            note.noteType === 'Alert' ? 'red.400' :
            note.noteType === 'FollowUp' ? 'yellow.400' : 'gray.300'
          }
        >
          <HStack justify="space-between" mb={2}>
            <HStack gap={2}>
              <Badge colorPalette={noteTypeColors[note.noteType] ?? 'gray'} size="sm">
                {note.noteType}
              </Badge>
              <Text fontSize="xs" color="gray.500">
                by {note.creatorName}
              </Text>
            </HStack>
            <Text fontSize="xs" color="gray.400">
              {new Date(note.createdAt).toLocaleString()}
            </Text>
          </HStack>
          <Text fontSize="sm">{note.noteText}</Text>
        </Box>
      ))}
    </VStack>
  );
}
